import {Icon} from './Icon';
import { useCallback, useRef, type ReactNode } from 'react';

export type AdvancedDetailsProps = Readonly<{
  children: ReactNode;
  className?: string | undefined;
  defaultOpen?: boolean | undefined;
  summary: string;
}>;

export function AdvancedDetails({ children, className, defaultOpen = false, summary }: AdvancedDetailsProps) {
  const initialised = useRef(false);
  const initialiseNativeDetails = useCallback((node: HTMLDetailsElement | null) => {
    if (!node || initialised.current) return;
    node.open = defaultOpen;
    initialised.current = true;
  }, [defaultOpen]);
  return <details
    className={['advanced-details', className].filter(Boolean).join(' ')}
    ref={initialiseNativeDetails}
  >
    <summary className="advanced-details__summary">{summary}<Icon name="chevron-down"/></summary>
    <div className="advanced-details__content">{children}</div>
  </details>;
}
